import { Button, Input, Space, Typography } from "antd";
import { FC, useState } from "react";
import { useStore } from "../../config/store";
import { IClean } from "../../config/types";
import { API } from "../../api";

export const BuyBlock = () => {
  const [text, setText] = useState("");
  const [uploading, setUploading] = useState(false);

  const { clean, cancelDrawer } = useStore();
  const { object_id, rent_id, id, cleaner_id } = clean as IClean;

  // const submitHandler = async () => {
  //   // await API.addComment({ text, clean_id });
  //   submit(text);
  // };

  const submitHandler = async () => {
    // await API.addComment({ text, clean_id });
    setUploading(true);
    await API.addTask({ text, clean_id: id, rent_id, object_id, cleaner_id, type: "buy" });
    setUploading(false);
    cancelDrawer();
    // submit(text, fileList[0]);
  };

  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Typography.Text>Что нужно купить на объект</Typography.Text>
      <Input.TextArea
        autoSize={{ minRows: 5 }}
        placeholder="Напишите комментарий"
        onChange={(e) => setText(e.target.value)}
      />
      <Button
        type="primary"
        block
        size="large"
        disabled={text.length === 0}
        onClick={submitHandler}
        loading={uploading}
      >
        Отправить
      </Button>
      <Button block size="large" onClick={cancelDrawer}>
        Отмена
      </Button>
    </Space>
  );
};
